module.exports = __webpack_public_path__ + "img/106@3x.64dc024a.png";